import React from 'react';
import styled from 'styled-components';
import validator from 'validator';
import axios from 'axios';
import get from 'lodash/get';
import {
  Typography,
  Button,
  TextField,
  InputAdornment,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@material-ui/core';
import { MdPhone, MdPerson } from 'react-icons/lib/md';

import { MOBILE_VIEW_BREAKPOINT } from '../../styles/constant';
import Loader from '../../components/Loader';
import KnowledgeTestForm from './components/KnowledgeTestForm';

class KnowledgeTestQuiz extends React.Component {
  state = {
    quizStarted: false,
    language: 'english',
    phone: '',
    phoneErrorMessage: null,
    candidateId: '',
    candidateIdErrorMessage: null,
    candidateUid: null,
    loading: false,
  };

  validateInputs = () => {
    const errors = {};

    if (!validator.isMobilePhone(this.state.phone, 'en-IN')) {
      errors.phoneErrorMessage = 'Invalid phone number';
    }
    if (validator.isEmpty(this.state.candidateId)) {
      errors.candidateIdErrorMessage = 'Field is required';
    }

    if (Object.keys(errors).length > 0) {
      this.setState(errors);
      return false;
    }
    return true;
  };

  verifyCandidate = async () => {
    this.setState({ loading: true });
    try {
      const userData = {
        contactNumber: this.state.phone,
        candidateID: this.state.candidateId,
      };
      const {
        data: { data },
      } = await axios.post(
        'https://us-central1-jyp-admin-saas.cloudfunctions.net/knowledgeTest/verify/',
        userData,
      );

      this.setState({ loading: false, candidateUid: data.id, quizStarted: true });
    } catch (error) {
      const errors = get(error.response, 'data.data.errors');
      this.setState({
        loading: false,
        phoneErrorMessage: errors.contactNumber || null,
        candidateIdErrorMessage: errors.candidateID || null,
      });
    }
  };

  render() {
    return (
      <Container>
        {!this.state.quizStarted ? (
          <LoginContainer>
            <LoginInfoContainer>
              <Typography variant="title" color="primary">
                Quiz Instructions
              </Typography>

              <ul>
                <li>
                  <Typography variant="subheading">
                    There are 10 single choice Questions to be answered.
                  </Typography>
                </li>
                <li>
                  <Typography variant="subheading">Each Questions carry 1 marks.</Typography>
                </li>
                <li>
                  <Typography variant="subheading">
                    You have 5 minutes to complete the test.
                  </Typography>
                </li>
              </ul>

              <LanguageSelectWrapper>
                <Typography variant="subheading">Choose the Quiz language</Typography>
                <StyledRadioGroup
                  aria-label="quiz-language"
                  name="quiz-language"
                  value={this.state.language}
                  onChange={(event) => {
                    const { value } = event.target;
                    this.setState({ language: value });
                  }}
                >
                  <FormControlLabel
                    value="english"
                    control={<Radio color="primary" />}
                    label="English"
                  />
                  <FormControlLabel
                    value="hindi"
                    control={<Radio color="primary" />}
                    label="Hindi"
                  />
                </StyledRadioGroup>
              </LanguageSelectWrapper>

              <InputContainer>
                <TextField
                  id="candidate-id-input"
                  placeholder="Candidate ID"
                  value={this.state.candidateId}
                  onChange={(event) => {
                    this.setState({
                      candidateId: event.target.value,
                      candidateIdErrorMessage: null,
                      phoneErrorMessage: null,
                    });
                  }}
                  helperText={this.state.candidateIdErrorMessage}
                  error={!!this.state.candidateIdErrorMessage}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdPerson size={24} />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="phone-input"
                  placeholder="Register Mobile Number"
                  value={this.state.phone}
                  onChange={(event) => {
                    this.setState({
                      phone: event.target.value,
                      phoneErrorMessage: null,
                      candidateIdErrorMessage: null,
                    });
                  }}
                  helperText={this.state.phoneErrorMessage}
                  error={!!this.state.phoneErrorMessage}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdPhone size={24} />
                      </InputAdornment>
                    ),
                  }}
                />
              </InputContainer>

              <ButtonContainer>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    if (this.validateInputs()) {
                      this.verifyCandidate();
                    }
                  }}
                >
                  Start Test
                </Button>
              </ButtonContainer>
            </LoginInfoContainer>

            <HeroImageContainer>
              <HeroImage
                src={require('../../images/knowledge-test-hero-image.svg')}
                alt="knowledge test hero image"
              />
            </HeroImageContainer>
          </LoginContainer>
        ) : (
          <KnowledgeTestForm
            language={this.state.language}
            candidateUid={this.state.candidateUid}
          />
        )}

        {this.state.loading && <Loader />}
      </Container>
    );
  }
}

export default KnowledgeTestQuiz;

const Container = styled.div`
  background-color: #fff;
  position: relative;
`;

const LoginContainer = styled.div`
  width: 90vw;
  max-width: 960px;
  height: 100vh;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 16px;

  @media (max-width: ${MOBILE_VIEW_BREAKPOINT}px) {
    grid-template-columns: 1fr;
  }
`;

const LoginInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const HeroImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: ${MOBILE_VIEW_BREAKPOINT}px) {
    display: none;
  }
`;

const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const LanguageSelectWrapper = styled.div`
  margin-top: 50px;
`;

const InputContainer = styled.div`
  margin-top: 10px;
  width: 70%;

  && {
    & > * + * {
      margin-top: 15px;
    }
  }
`;

const ButtonContainer = styled.div`
  margin-top: 20px;
`;

const StyledRadioGroup = styled(RadioGroup)`
  display: flex !important;
  align-items: center !important;
  flex-direction: row !important;
`;



// WEBPACK FOOTER //
// ./src/pages/KnowledgeTestQuiz/KnowledgeTestQuiz.js